import React, { useRef, useState } from 'react';
import { View, StyleSheet, TouchableOpacity, useWindowDimensions, ScrollView, TextInput } from 'react-native';
import { ZenIcon, ZenText, ZenToast } from 'zen-core-elements';
import { ThemeConsumer } from '@rneui/themed';
import { Theme } from '@rneui/themed';
import SellscreenModal from '../../sellscreenModal';
import CashPayment from './cashPayment';
import { getPaymentMode, isCustomerOnAccountEligible, PAYMENT_METHODS } from '../../../../redux/utils/discountUtils';
import PaymentNotes from './paymentNotes';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import { setTransactionData } from '../../../../redux/slices/newSellscreenPaymentSlice';
import { config } from '../../../../shared/environment';
import { paymentSaveType } from '../../../../redux/types/sellScreenTypes';
import GiftCardPayment from './giftCartPayment';
import StoreCreditPayment from './storeCreditPayment';
import OnAccountPayment from './onAccountPayment';
import RefundPayment from './refundPayment';
import { updateOrderDetails, updateOrderPayload } from '../../../../redux/slices/orderSlice';
import moment from 'moment';
import { updateRefundAmount, updateReturnProductStatus } from '../../../../redux/slices/orderDetailSlice';
import { addCustomer, clearCart } from '../../../../redux/slices/newSellscreenSlice';
import { useAppNavigation } from '../../../../types/@react-navigation/navigation';
// import * as CryptoJs from 'react-native-crypto-js';
import { webDialogWidth } from '../../../../platform/design/dialogWeb';

const SinglePayment = () => {
	const dispatch = useAppDispatch()
	const { width, height } = useWindowDimensions()
	const inputRef = useRef<TextInput>(null);
	const [paymentMethod, setPaymentMethod] = useState<typeof PAYMENT_METHODS[0]["id"]>("")
	const { customerDetails, sellScreenType, returnRequestData, summary } = useAppSelector((state) => state.NewSellscreenSlice)
	const { totalAmount } = useAppSelector((state) => state?.NewSellscreenPaymentSlice)
	const checkoutGiftCart = useAppSelector((state) => state?.sellScreen?.checkoutGiftCart)
	const isBuyingGiftCard = Boolean(checkoutGiftCart?.giftCardValue?.value || checkoutGiftCart?.giftCardValue)

	const onPressPaymentMethod = (id: typeof PAYMENT_METHODS[0]["id"]) => {
		if (customerDetails?.id) {
			setPaymentMethod(id)
		} else {
			ZenToast({ type: "warning", message: "Please select a customer to proceed" })
		}
	}

	const onPaymentSave = ({ amount, paidAmount, reason = "", giftCardId = null, giftCardPayment = null, storeCreditId = null }: paymentSaveType) => {
		dispatch(setTransactionData({
			data: {
				storeId: config?.storeId,
				paymentMode: getPaymentMode(paymentMethod),
				paymentStatus: storeCreditId ? "PENDING" : "SUCCESS",
				amount,
				reason,
				giftCardId,
				storeCreditId,
				_completed: true,
				_id: new Date().getTime().toString(),
				_paymentMethod: paymentMethod,
				_paidAmount: paidAmount,
				_giftCardPayment: giftCardPayment
			}
		}))
		setPaymentMethod('')
	}





	const onPaymentClose = () => {
		setPaymentMethod('')
		inputRef?.current?.blur()
	}

	const availablePaymentMethods = PAYMENT_METHODS.filter((item) => {
		if (isBuyingGiftCard && (item.id === "Gift Card" || item.id === "Store Credit" || item.id === "On Account")) {
			return false;
		}
		if (item.id === "On Account") {
			return isCustomerOnAccountEligible(customerDetails, totalAmount);
		}

		return true;
	});

	return (
		<ThemeConsumer>
			{({ theme }) => {
				const styles = style(theme)
				return (
					<ScrollView>
						<View style={styles.methodGridContainer}>
							{availablePaymentMethods.map((item) => (
								<TouchableOpacity
									key={item.id}
									onPress={() => onPressPaymentMethod(item.id)}
									style={[
										styles.methodGrid,
										paymentMethod === item.id && styles.activeCard,
									]}
								>
									<View
										style={[
											styles.iconCircle,
											{ backgroundColor: item.color + "15" },
										]}
									>
										<ZenIcon
											name={item.icon}
											type="material-community"
											size={28}
											color={item.color}
										/>
									</View>

									<ZenText content={item.id} style={[styles.methodLabelText, paymentMethod === item.id && { fontFamily: theme?.bold }]} />

									{paymentMethod === item.id && (
										<View style={styles.checkBadge}>
											<ZenIcon
												name="check"
												type="material-community"
												size={12}
												color={theme?.light}
											/>
										</View>
									)}
								</TouchableOpacity>
							))}
						</View>
						{/* <SellscreenModal isModalOpen={paymentMethod ? true && sellScreenType == "RETURN" : false} onCloseRequest={onPaymentClose}>
							<View style={{ minWidth: width > 900 ? width * 0.4 : width > 600 ? width * 0.60 : width * 0.80, maxHeight: width > 900 ? height * 0.80 : height * 0.60 }}>
								<RefundPayment
									paymentMethod={paymentMethod}
									totalAmount={totalAmount}
									customerDetails={customerDetails}
									onClose={onPaymentClose}
									handleRefund={handleRefund}
								/>
							</View>
						</SellscreenModal> */}
						<SellscreenModal onShow={() => setTimeout(() => inputRef?.current?.focus(), 100)} isModalOpen={paymentMethod ? true && sellScreenType !== "RETURN" : false} onCloseRequest={onPaymentClose}>
							<View style={[{ minWidth: width > 900 ? width * 0.4 : width > 600 ? width * 0.60 : width * 0.80, maxHeight: width > 900 ? height * 0.80 : height * 0.60 }, webDialogWidth('md', width)]}>
								{paymentMethod == "Cash" ? <CashPayment
									inputRef={inputRef}
									handleSave={onPaymentSave}
									onClose={onPaymentClose}
								/> :
									paymentMethod == "Gift Card" ? <GiftCardPayment
										inputRef={inputRef}
										handleSave={onPaymentSave}
										onClose={onPaymentClose}
									/> :
										paymentMethod == "Store Credit" ? <StoreCreditPayment
											inputRef={inputRef}
											handleSave={onPaymentSave}
											onClose={onPaymentClose}
										/> :
											paymentMethod == "On Account" ? <OnAccountPayment
												inputRef={inputRef}
												handleSave={onPaymentSave}
												onClose={onPaymentClose}
											/> :
												<PaymentNotes
													handleSave={onPaymentSave}
													onClose={onPaymentClose}
													inputRef={inputRef}
													paymentMethod={paymentMethod}
												/>}
							</View>
						</SellscreenModal>

					</ScrollView>
				)
			}}
		</ThemeConsumer>
	);
};

const style = (theme: Theme) => StyleSheet.create({
	// Method Grid
	methodGridContainer: {
		flexDirection: "row",
		flexWrap: "wrap",
		paddingHorizontal: 16,
		justifyContent: "flex-start",
	},

	methodGrid: {
		width: "25%",
		marginBottom: 12,
		paddingVertical: 16,
		borderRadius: 12,
		alignItems: "center",
	},
	activeCard: { borderColor: theme?.primary, borderWidth: 1.5, backgroundColor: theme?.light },
	iconCircle: { width: 60, height: 60, borderRadius: 30, justifyContent: 'center', alignItems: 'center', marginBottom: 12 },
	methodLabelText: { fontFamily: theme?.medium, color: theme?.lightDark, fontSize: theme?.smallHeaderFontSize },
	checkBadge: { position: 'absolute', top: 12, right: 12, width: 20, height: 20, borderRadius: 10, backgroundColor: theme?.primary, justifyContent: 'center', alignItems: 'center' },

});

export default SinglePayment;


